/** @format */

import React, { FunctionComponent } from 'react';
import I18n from '../../components/Translate/I18n';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Typography } from '@material-ui/core';

export const DefinitionHeaderElement: FunctionComponent<any> = () => {
    return (
        <TableRow>
            <TableCell padding="none" align="left">
                <Typography variant="body1">
                    <I18n trans="prov:view.if_status" />
                </Typography>
            </TableCell>
            <TableCell padding="none" align="right">
                <Typography variant="body1">
                    <I18n trans="prov:view.call" />
                </Typography>
            </TableCell>
        </TableRow>
    );
};
